import { MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function Map() {
  return <section id="map" className="py-12 md:py-16 bg-background">
      <div className="page-container">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">Noch Fragen zu Ihrem Umzug oder Ihrer Renovierung?</h2>
          <p className="text-muted-foreground text-lg"><div>Unser Team berät Sie sofort persönlich und kostenlos.</div></p>
        </div>

        <div className="relative w-full h-[450px] md:h-[550px] rounded-lg overflow-hidden shadow-md border border-border bg-muted">
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/map_cologne_location_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/map_cologne_location_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/map_cologne_location_bg.png-wvc-sizes" alt="Karte von Köln mit Standort" className="absolute inset-0 w-full h-full object-cover opacity-40 mix-blend-multiply dark:mix-blend-screen dark:opacity-20" loading="lazy" />

          {}
          <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
            <div className="relative flex flex-col items-center transform -translate-y-6">
              {}
              <Card className="mb-4 shadow-lg border-border/50 bg-background/95 backdrop-blur-sm w-[280px] text-center z-10">
                <CardContent className="p-6 flex flex-col items-center gap-3">
                  <div>
                    <h3 className="font-semibold font-default text-lg text-foreground">
                      Renovierungen Schneider
                    </h3>
                    <p className="text-sm text-muted-foreground mt-1 !border-dashed !border-1 border-[rgb(115,115,115)]">Schillerstr. 14, 32257 Bünde<br /><br />Mobil:&nbsp; 0172 62 74 452</p>
                  </div>
                  <Button asChild variant="default" size="sm" className="w-full mt-2">
                    <Link to="tel:+491726274452">Jetzt Anrufen</Link>
                  </Button>
                </CardContent>
              </Card>

              {}
              <div className="relative z-0">
                <MapPin className="w-14 h-14 text-primary drop-shadow-md" strokeWidth={1.5} fill="currentColor" style={{
                fillOpacity: 0.15
              }} />
                {}
                <div className="absolute bottom-1.5 left-1/2 transform -translate-x-1/2 w-6 h-1.5 bg-black/20 rounded-lg blur-[2px] -z-10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}